"use strict";

exports.__esModule = true;
exports.default = void 0;

function getPlatform() {
  var platform = navigator.platform;

  if (platform) {
    if (/(iphone|ipod|ipad)/.test(navigator.userAgent.toLowerCase())) return 'iOS';
    if (/android/.test(navigator.userAgent.toLowerCase())) return 'Android';
    return platform;
  }
}

var _module = {};
var platform;
[{
  key: 'appName',
  getFn: function getFn() {
    return navigator.appName;
  }
}, {
  key: 'platform',
  getFn: function getFn() {
    if (!platform) {
      platform = getPlatform();
    }

    return platform;
  }
}, {
  key: 'screenWidth',
  getFn: function getFn() {
    return window.screen.width;
  }
}, {
  key: 'screenHeight',
  getFn: function getFn() {
    return window.screen.height;
  }
}, {
  key: 'appVersion',
  getFn: function getFn() {
    return navigator.appVersion;
  }
}, {
  key: 'devicePixelRatio',
  getFn: function getFn() {
    return window.devicePixelRatio;
  }
}].forEach(function (_ref) {
  var key = _ref.key,
      getFn = _ref.getFn;
  Object.defineProperty(_module, key, {
    get: getFn
  });
});
var _default = _module;
exports.default = _default;